/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Website API
 * The backend API for the website SPA
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  GetRouteParams,
  RouteResponse
} from './data.schemas'




export const getRoute = (
    params: GetRouteParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RouteResponse>> => {
    
    return axios.default.get(
      `/api/routing`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetRouteQueryKey = (params: GetRouteParams,) => {
    return [`/api/routing`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRouteQueryOptions = <TData = Awaited<ReturnType<typeof getRoute>>, TError = AxiosError<unknown>>(params: GetRouteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoute>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRouteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoute>>> = ({ signal }) => getRoute(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn,   staleTime: 3600000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRoute>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRouteQueryResult = NonNullable<Awaited<ReturnType<typeof getRoute>>>
export type GetRouteQueryError = AxiosError<unknown>

export const useGetRoute = <TData = Awaited<ReturnType<typeof getRoute>>, TError = AxiosError<unknown>>(
 params: GetRouteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoute>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRouteQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



